import { ReactNode } from "react";
import './panel.css'

export default function Panel(props:{children: ReactNode}){
    return  <div className="panel">
        {props.children}
    </div>;  
}    